import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import { computed, ref } from "vue";
import PlaintextSegment from "./PlaintextSegment.vue";
import RendertimeVariableSegment from "./RendertimeVariableSegment.vue";
import BuildtimeVariableSegment from "./BuildtimeVariableSegment.vue";
import { calculateStringHandlebarsPreviewSegments, } from ".";
const overflowThreshold = 144;
export default /*#__PURE__*/ _defineComponent({
    __name: 'HandlebarsEvaluatablePreview',
    props: {
        componentId: {},
        value: {},
        variant: {}
    },
    setup(__props) {
        const props = __props;
        const handlebarsPreview = ref(null);
        const scrollHeightOfHandlebarsPreview = computed(() => {
            if (handlebarsPreview.value === null)
                return 0;
            return handlebarsPreview.value.scrollHeight;
        });
        const isOverflowing = computed(() => {
            return scrollHeightOfHandlebarsPreview.value > overflowThreshold;
        });
        const segments = computed(() => {
            if (typeof props.value !== "string")
                return [];
            return calculateStringHandlebarsPreviewSegments(props.value);
        });
        const getSegmentComponent = (segmentType) => {
            switch (segmentType) {
                case "component-variable":
                    return BuildtimeVariableSegment;
                case "rendertime-variable":
                    return RendertimeVariableSegment;
                default:
                    return PlaintextSegment;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["handlebars-evaluatable-preview-v2", {
                        'handlebars-evaluatable-preview--overflowing': isOverflowing.value,
                    }]),
                ref_key: "handlebarsPreview",
                ref: handlebarsPreview
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (segment, index) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(getSegmentComponent(segment.type)), {
                        key: index,
                        value: segment.value,
                        "component-id": props.componentId,
                        dimension: _ctx.variant
                    }, null, 8 /* PROPS */, ["value", "component-id", "dimension"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */));
        };
    }
});
